import { Grid, Table } from '@mui/material';
import React from 'react';
import TabelleEntries from '../../../TabelleEntries';
import useBSSLogger from "../../../../hooks/useBSSLogger";
import __t from '../../../../lib/traduzioni';
const {logger} = useBSSLogger();

//tab con il preventivo e i servizi aggiuntivi selezionati dall'utente
const TabProdotto = ({ ordine, tabObj }) => {

    const { prodotto, servizi = [] } = ordine;

    const tabella = {
        [__t("prodottoeserviziscelti")]: {
            [__t("prodotto")]: prodotto?.multiDescr?.testo ?? null,
            ...(servizi.reduce((obj, servizio) => ({
                ...obj,
                [`${servizio.servizio.nome.testo} ${['D', 'I'].includes(servizio.servizio.tipo.value) ? __t("per") : ''}`]: servizio.servizio.tipo.value === "D" ?
                    servizio.importoimputato.toFixed(2) :
                    servizio.servizio.tipo.value === "B" ?
                        true :
                        servizio.importoimputato
            }), {}))
        }
    };

    return (
        <>
            <Grid container columns={12} spacing={2}>
                <Grid item xs={12}>
                    <TabelleEntries wrapped tabelle={tabella} />
                </Grid>
            </Grid>
        </>
    );
};

export default TabProdotto;